<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs>

              <CTab :title="$t('buyFactorCurrency')">
                <AddDocumentCurrency/>
              </CTab>
              <CTab :title="$t('tempBuyCurrencyFactors')">
                <CurrencyBuyDocumentList :selected_type="1"/>
              </CTab>
              <CTab :title="$t('reportCurrencyBuyFactor')">
                <CurrencyBuyDocumentListFinal :selected_type="2"/>
              </CTab>
            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
var items = [];
import BTabs from "../../tabs/BTabs";
import CurrencyBuyDocumentList from "./CurrencyBuyDocumentList";
import AddDocumentCurrency from "../documents/AddDocumentCurrency";
import CurrencyBuyDocumentListFinal from "./CurrencyBuyDocumentListFinal";
export default {
  name: 'Login',
  components: {
    BTabs,
    CurrencyBuyDocumentListFinal,
    CurrencyBuyDocumentList,
    AddDocumentCurrency,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

  }, watch: {

  },
  methods: {

  }
}

</script>
